(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/transactions-slice.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/transactions-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const getTransactionsAsync = svs.arena.service.transactionsService.getTransactionsAsync;
const fetchTransactions = RTK.createAsyncThunk('arena/fetchtransactions', async (options, _ref) => {
  let rejectWithValue = _ref.rejectWithValue;
  if (!options.syndicateId) {
    return rejectWithValue({
      error: 'option syndicateId is missing'
    });
  }
  try {
    const response = await getTransactionsAsync(options);
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    return {
      status: 'success',
      error: null,
      fromTimeUuid: options.transactionTimeUuid,
      syndicateId: options.syndicateId,
      data: response
    };
  } catch (error) {
    return rejectWithValue({
      data: {},
      error,
      syndicateId: options.syndicateId
    });
  }
});

const getInitialState = () => ({});
const transactionsSlice = RTK.createSlice({
  name: 'transactions',
  initialState: getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchTransactions.fulfilled, (state, action) => {
      if (action.payload.syndicateId) {
        var _state$action$payload;
        state[action.payload.syndicateId] = {
          transactions: [...(action.payload.fromTimeUuid ? ((_state$action$payload = state[action.payload.syndicateId]) === null || _state$action$payload === void 0 ? void 0 : _state$action$payload.transactions) || [] : []), ...action.payload.data.transactions],
          hasMoreItems: action.payload.data.hasMoreItems,
          latestFetch: new Date().getTime(),
          error: action.payload.error
        };
      }
    });
  }
});
svs.arena.store.transactions = svs.arena.store.transactions || {};
svs.arena.store.transactions.actions = _objectSpread({
  fetchTransactions
}, transactionsSlice.actions);
svs.arena.store.transactions.reducer = transactionsSlice.reducer;
svs.arena.store.transactions.initialState = getInitialState();

 })(window);